export { TextInput } from './text-input';
export type { TextInputProps, TextInputStylesNames } from './text-input';
